import { useState } from 'react';
import MainPanel from '../components/MainPanel/MainPanel';
import DefaultLayout from '../layout/Layout';

const Inventory = () => {
  const [show, setShow] = useState(false);
  return (
    <DefaultLayout isLogin={false}>
      <MainPanel>
        <div>
          <button
            className="rounded-md bg-primary px-9 py-3 font-medium text-white hover:bg-opacity-90"
            onClick={() => setShow(true)}
          >
            Modal 1
          </button>
          <div
            className={`fixed left-0 top-0 z-999999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5 ${
              show ? 'show' : 'hidden'
            }`}
          >
            <div className="md:px-17.5 w-full max-w-142.5 rounded-lg bg-white px-8 py-12 text-center dark:bg-boxdark md:py-15">
              <h3 className="pb-2 text-xl font-bold text-black dark:text-white sm:text-2xl">
                Your Message Sent Successfully
              </h3>
              <span className="mx-auto mb-6 inline-block h-1 w-22.5 rounded bg-primary"></span>
              <p className="mb-10">
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since
              </p>
              <div className="-mx-3 flex flex-wrap gap-y-4">
                <div className="2xsm:w-1/2 w-full px-3">
                  <button
                    onClick={() => setShow(false)}
                    className="block w-full rounded border border-stroke bg-gray p-3 text-center font-medium text-black transition hover:border-meta-1 hover:bg-meta-1 hover:text-white dark:border-strokedark dark:bg-meta-4 dark:text-white dark:hover:border-meta-1 dark:hover:bg-meta-1"
                  >
                    Cancel
                  </button>
                </div>
                <div className="2xsm:w-1/2 w-full px-3">
                  <button className="block w-full rounded border border-primary bg-primary p-3 text-center font-medium text-white transition hover:bg-opacity-90">
                    View Details
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MainPanel>
    </DefaultLayout>
  );
};
export default Inventory;
